
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ghbV_XqAVGFBMSBneyFsEJSFCEy5uiy9_456IJ_SPrVoJEMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexmUgCvDOFJXuYh5glbwOxQLy7DPoLxqO3D5T6uoHZX2UMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchD6M8c5gLIwTKl_2uWH_0zw4kKtD0oyKeAZSX4Wggn9gMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexri6hpbFm5cGxz3Ka03M2kndbnimBTU_mkiQt0ZCrFhgMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_931l_45Qn4O0iCzAHxx3sWLRc4gqrEnlBWrZJLVbVImSRRcMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexLQj3bEj26puLObTti_D7nC_45e_45ZMr_45OxZaVft2dfAxEoMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_45SWWAY5hM5L2vo6CiOkZegjNq_453TKMhbKxgNSTAHEtQMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexOiVGk_bzX791qA6LykF9Bp0iXdcsp5jixtPHeI0S6IUMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93km2sKreqRAD_45nxctp50Ogx4hiUGahpmc3_459F6uWtIoUMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmPAYGmySF01GEGyLKQIdJDowe8hPTODUzfx9kPC0GyIMeta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexj6eEtUlPPnQNtSRjP4TU0ylJYqhM7l8wVIuQG8SpCP8Meta } from "/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexLQj3bEj26puLObTti_D7nC_45e_45ZMr_45OxZaVft2dfAxEoMeta || {},
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexOiVGk_bzX791qA6LykF9Bp0iXdcsp5jixtPHeI0S6IUMeta || {},
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmPAYGmySF01GEGyLKQIdJDowe8hPTODUzfx9kPC0GyIMeta || {},
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexj6eEtUlPPnQNtSRjP4TU0ylJYqhM7l8wVIuQG8SpCP8Meta || {},
    component: () => import("/codebuild/output/src2108883060/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]